
import axios from '@/axios.js'
import url from '@/url.js'

export default {
  addFile({ }, payload) {
    return new Promise((resolve, reject) => {
      let form = new FormData()
      form.append('file', payload)
      const conn = {
        method: 'post',
        url: `${url.baseFl}/files`,
        data: form,
        headers: {
          'content-type': 'multipart/form-data',
          'secret': url.secretFl
        }
      }
      axios(conn).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    }
    )
  },
  
}
